import type {SafeHTMLString} from '@github-ui/safe-html'
import {SafeHTMLText} from '@github-ui/safe-html'
import {Link} from '@primer/react'
import {useMemo} from 'react'
import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {VALUES} from '../constants'
import type {LabelData$key} from './__generated__/LabelData.graphql'
import {LabelToken} from '@github-ui/label-token'

type LabelProps = {
  queryRef: LabelData$key
  timelineEventBaseUrl: string
}

export function Label({queryRef, timelineEventBaseUrl}: LabelProps): JSX.Element {
  const {
    nameHTML,
    name,
    color,
    id,
    repository: {
      name: repoName,
      owner: {login: ownerLogin},
    },
  } = useFragment(
    graphql`
      fragment LabelData on Label {
        nameHTML
        name
        color
        id
        repository {
          name
          owner {
            login
          }
        }
      }
    `,
    queryRef,
  )

  const url = useMemo(() => {
    return `${timelineEventBaseUrl}?q=${encodeURIComponent(VALUES.labelQuery(ownerLogin, repoName, name))}`
  }, [timelineEventBaseUrl, ownerLogin, repoName, name])

  return (
    <Link href={url} sx={{color: 'fg.default'}} muted>
      <LabelToken
        text={<SafeHTMLText html={nameHTML as SafeHTMLString} />}
        fillColor={`#${color}`}
        key={id}
        style={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '20ch',
          cursor: 'pointer',
        }}
      />
    </Link>
  )
}

try{ Label.displayName ||= 'Label' } catch {}